export default "__VITE_ASSET__C5eYHv_$__"